import { isEmpty } from "lodash";
import { getDictionary } from "../utilities/utilities";
import { Company } from "./Company";
import { Role } from "./Role";
import { Validate } from "./Validate";

const dictionary = getDictionary();

export interface User {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  ownerId: string;
  owner: Company;
  email: string;
  password: string;
  confirmPassword: string;
  name: string;
  surname: string;
  timeZone: any;
  lastPwdChangeDate: string;
  lastActivityDate: string;
  lastLoginDate: string;
  enabled: boolean;
  locked: boolean;
  credentialsExpired: boolean;
  expired: boolean;
  roles: Role[];
  archived: boolean;
  expectedAmount: string;
}

export interface CreateUser {
  id?: string;
  name: string;
  surname: string;
  email: string;
  timeZone: string;
  ownerId: string;
  password: string;
  roles: Role[];
}

// Interface for PUT (to update an existing Article)
export interface UpdateUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  timeZone: string;
  ownerId: string;
  enabled: boolean;
  roles: Role[];
}

export const defaultUser: Partial<User> = {
  enabled: true,
};

// Convert function to create
export const convertUserToCreate = (user: User): CreateUser => {
  return {
    name: user.name,
    surname: user.surname,
    email: user.email,
    timeZone: user.timeZone.value,
    ownerId: user.owner.id,
    password: user.password,
    roles: user.roles,
  };
};

// Convert function to update
export const convertUserToUpdate = (user: User): UpdateUser => {
  return {
    id: user.id,
    name: user.name,
    surname: user.surname,
    email: user.email,
    timeZone: user.timeZone.value,
    ownerId: user.owner.id || user.ownerId,
    enabled: user.enabled,
    roles: user.roles,
  };
};

export const validate = (user: User): Validate => {
  const validate: Validate = { isValid: true, errors: {} };
  if (!user.name) {
    validate.errors.name = dictionary.messages.mandatory_field;
  }
  if (!user.surname) {
    validate.errors.surname = dictionary.messages.mandatory_field;
  }
  if (!user.email) {
    validate.errors.email = dictionary.messages.mandatory_field;
  }
  if (!user.timeZone) {
    validate.errors.timeZone = dictionary.messages.mandatory_field;
  }
  if (!user.owner?.id) {
    validate.errors.owner = dictionary.messages.mandatory_field;
  }
  if (!user.id) {
    if (!user.password) {
      validate.errors.password = dictionary.messages.mandatory_field;
    }
    if (!user.confirmPassword) {
      validate.errors.confirmPassword = dictionary.messages.mandatory_field;
    }
    if (user.password !== user.confirmPassword) {
      validate.errors.confirmPassword = dictionary.users.passwords_must_match;
    }
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }

  return validate;
};

export interface ResetPasswordUser {
  id?: string;
  password: string;
  confirmPassword: string;
}

export const validateResetPassword = (user: ResetPasswordUser): Validate => {
  const validate: Validate = { isValid: true, errors: {} };

  if (!user.password) {
    validate.errors.password = dictionary.messages.mandatory_field;
  }
  if (!user.confirmPassword) {
    validate.errors.confirmPassword = dictionary.messages.mandatory_field;
  }
  if (user.password !== user.confirmPassword) {
    validate.errors.confirmPassword = dictionary.users.passwords_must_match;
  }

  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }

  return validate;
};
